var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas"},[_vm._l((_vm.ballList),function(item,index){return [_c('img',{key:item.id,class:['scale','scale' + index],style:({
        'width': item.size + 'px',
        'height': item.size + 'px',
        'z-index': item.zIndex,
        'left': item.x + 'px',
        'top': item.y + 'px'
      }),attrs:{"src":item.img,"alt":""}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }